/* istanbul ignore file */
import React from 'react';
import { EnumField, HtmlField } from 'framework/ui/field';
import { TEMPLATE_TYPES } from 'domain/sales/opportunity/presale/contract/shared/contractRequestService';
import { AttachmentsListField } from 'domain/shared/artifact/field';

const ContractRequestFields = () => {
  return (
    <>
      <EnumField options={TEMPLATE_TYPES} source="templateType" label="Template Type" />
      <HtmlField source="descriptionText" label="Description" />
      <AttachmentsListField source="attachmentIds" label="Attachments" />
    </>
  );
};

export default ContractRequestFields;
